export { default } from "./ResourcePageSchoolDetails";
